import { Directive, ElementRef, Input, OnInit, OnDestroy, Renderer2, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appCarouselDrag]',
  standalone: true
})
export class CarouselDragDirective implements OnInit, OnDestroy, OnChanges {
  @Input() carouselRef: any;
  @Input() enableDrag: boolean = true; // Nuovo input per abilitare/disabilitare il drag

  private isDragging = false;
  private startX = 0;
  private scrollLeft = 0;
  private unlistenMouseDown?: () => void;
  private unlistenMouseMove?: () => void;
  private unlistenMouseUp?: () => void;
  private unlistenMouseLeave?: () => void;
  private container: any;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.container = this.el.nativeElement.querySelector('.p-carousel-items-container');
    if (!this.container) {
      return;
    }
    
    // Configura i listener solo se il drag è abilitato
    if (this.enableDrag) {
      this.setupDragListeners();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Se enableDrag cambia, aggiorna i listener
    if (changes['enableDrag'] && !changes['enableDrag'].isFirstChange()) {
      if (this.enableDrag) {
        this.setupDragListeners();
      } else {
        this.removeDragListeners();
      }
    }
  }

  private setupDragListeners(): void {
    if (!this.container) {
      return;
    }
    
    // Rimuovi eventuali listener esistenti prima di aggiungerne di nuovi
    this.removeDragListeners();

    // Mouse down
    this.unlistenMouseDown = this.renderer.listen(this.container, 'mousedown', (e: MouseEvent) => {
      this.isDragging = true;
      this.startX = e.pageX - this.container.offsetLeft;
      this.scrollLeft = this.container.scrollLeft;
      this.renderer.setStyle(this.container, 'cursor', 'grabbing');
      e.preventDefault();
    });

    // Mouse move
    this.unlistenMouseMove = this.renderer.listen(this.container, 'mousemove', (e: MouseEvent) => {
      if (!this.isDragging) return;
      e.preventDefault();
      const x = e.pageX - this.container.offsetLeft;
      const walk = (x - this.startX) * 2; // Moltiplicatore per la velocità di scroll
      
      // Se il movimento è abbastanza significativo, naviga
      if (Math.abs(walk) > 50) {
        if (walk < 0 && this.carouselRef) {
          // Swipe verso sinistra -> vai avanti
          this.carouselRef.navForward();
          this.isDragging = false;
        } else if (walk > 0 && this.carouselRef) {
          // Swipe verso destra -> vai indietro
          this.carouselRef.navBackward();
          this.isDragging = false;
        }
      }
    });

    // Mouse up
    this.unlistenMouseUp = this.renderer.listen(this.container, 'mouseup', () => {
      this.isDragging = false;
      this.renderer.setStyle(this.container, 'cursor', 'grab');
    });

    // Mouse leave
    this.unlistenMouseLeave = this.renderer.listen(this.container, 'mouseleave', () => {
      this.isDragging = false;
      this.renderer.setStyle(this.container, 'cursor', 'grab');
    });

    // Imposta il cursore iniziale
    this.renderer.setStyle(this.container, 'cursor', 'grab');
  }

  private removeDragListeners(): void {
    // Rimuovi tutti i listener
    if (this.unlistenMouseDown) {
      this.unlistenMouseDown();
      this.unlistenMouseDown = undefined;
    }
    if (this.unlistenMouseMove) {
      this.unlistenMouseMove();
      this.unlistenMouseMove = undefined;
    }
    if (this.unlistenMouseUp) {
      this.unlistenMouseUp();
      this.unlistenMouseUp = undefined;
    }
    if (this.unlistenMouseLeave) {
      this.unlistenMouseLeave();
      this.unlistenMouseLeave = undefined;
    }
    
    // Ripristina il cursore di default
    if (this.container) {
      this.renderer.setStyle(this.container, 'cursor', 'default');
    }
  }

  ngOnDestroy(): void {
    this.removeDragListeners();
  }
}
